/**
 * Place an element behind one or more elements on the screen, using ill advised absolute positioning.
 */
; window.showBehind = (() => {

    // Exported functions
    const exported = {}

    // Map of elements we are currently placing behind other elements
    const currentElements = []

    // Normalize the element(s) to an array
    function elementsAsArray(elements) {
        if (elements instanceof NodeList) {
            return Array.from(elements)
        } else if (Array.isArray(elements)) {
            return elements
        } else {
            return [elements]
        }
    }

    // Create a bounding box for one or more elements on the screen
    function getJointBoundingBox(elementsArray) {
        const boundingBoxes = elementsArray.map(element => element.getBoundingClientRect())
        const top = Math.min(...boundingBoxes.map(box => box.top))
        const left = Math.min(...boundingBoxes.map(box => box.left))
        const right = Math.max(...boundingBoxes.map(box => box.right))
        const bottom = Math.max(...boundingBoxes.map(box => box.bottom))
        return { top, left, right, bottom }
    }

    // Get the common ancestor of a list of elements
    function getCommonAncestor(elementsArray) {

        // For each element, create the list of its ancestors
        const ancestors = elementsArray.map(element => {
            const ancestors = []
            let ancestor = element.parentElement
            while (ancestor) {
                ancestors.push(ancestor)
                ancestor = ancestor.parentElement
            }
            return ancestors
        })

        // Find the common ancestor
        let commonAncestor = null
        for (let i = 0; i < ancestors[0].length; i++) {
            let ancestor = ancestors[0][i]
            if (ancestors.every(ancestorList => ancestorList.includes(ancestor))) {

                // Check the ancestor is not a special element like a table, and can take a div
                if (ancestor.tagName === 'TABLE' || ancestor.tagName === 'TBODY' || ancestor.tagName === 'TR' || ancestor.tagName === 'TD') {
                    continue
                }
                // Check the ancestor is not a special element like a list, and can take a div
                if (ancestor.tagName === 'UL' || ancestor.tagName === 'OL' || ancestor.tagName === 'LI') {
                    continue
                }
                // Probably more special cases can be added here

                // If all elements have this ancestor, we found the common ancestor and break the loop
                commonAncestor = ancestor
                break
            }
        }
        return commonAncestor
    }

    // Place a absolutely positioned element behind a set of elements based on their bounding box and common ancestor
    exported.placeElementBehind = function (elements, element, padding = { top: 0, right: 0, bottom: 0, left: 0 }) {
        elements = elementsAsArray(elements)

        const boundingBox = getJointBoundingBox(elements)
        const commonAncestor = getCommonAncestor(elements)
        const ancestorRect = commonAncestor.getBoundingClientRect()

        // If element is a string of HTML, create a new element
        if (typeof element === 'string') {
            const div = document.createElement('div')
            div.innerHTML = element
            element = div.firstElementChild
        }

        // If element is null, create a debug element
        if (!element) {
            element = document.createElement('div')
            element.style.backgroundColor = 'tomato'
        }

        // If the ancestor is not position relative or absolute, make it relative
        const ancestorStyle = window.getComputedStyle(commonAncestor)
        if (ancestorStyle.position !== 'relative' && ancestorStyle.position !== 'absolute') {
            commonAncestor.style.position = 'relative'
        }

        // Set the position and size of the element
        element.style.position = 'absolute'
        element.style.top = boundingBox.top - ancestorRect.top + 'px'
        element.style.left = boundingBox.left - ancestorRect.left + 'px'
        element.style.width = boundingBox.right - boundingBox.left + 'px'
        element.style.height = boundingBox.bottom - boundingBox.top + 'px'
        element.style.zIndex = -1

        // Add padding
        element.style.top = parseFloat(element.style.top) - padding.top + 'px'
        element.style.left = parseFloat(element.style.left) - padding.left + 'px'
        element.style.width = parseFloat(element.style.width) + padding.left + padding.right + 'px'
        element.style.height = parseFloat(element.style.height) + padding.top + padding.bottom + 'px'

        // Insert the element in the common ancestor
        commonAncestor.appendChild(element)

        // Store or replace the element in the global array
        const existingElement = currentElements.find(item => item.elements === elements)
        if (existingElement) {
            existingElement.element = element
        } else {
            currentElements.push({ elements, element, padding })
        }
    }

    // Update the elements placed behind the elements
    exported.updateBehindElements = function () {
        currentElements.forEach(({ elements, element, padding }) => {
            showBehind.placeElementBehind(elements, element, padding)
        })
    }

    // Remove the element placed behind the elements
    exported.removeBehindElement = function (elements) {
        elements = elementsAsArray(elements)
        const existingElement = currentElements.find(item => item.elements === elements)
        if (existingElement) {
            existingElement.element.remove()
            currentElements.splice(currentElements.indexOf(existingElement), 1)
        }
    }

    // Keep the elements behind the elements when the window is resized
    window.addEventListener('resize', () => {
        window.requestAnimationFrame(() => {
            showBehind.updateBehindElements()
        })
    })

    return exported

})()
